var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3483 5.01562C19.5073 5.01562 20.4478 5.91905 20.4478 7.03441C20.4478 8.14888 19.5073 9.05231 18.3483 9.05231C17.1893 9.05231 16.2488 8.14888 16.2488 7.03441C16.2488 5.91905 17.1893 5.01562 18.3483 5.01562Z",
    stroke: "#E07E9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0771 12.3602C19.9884 14.0997 19.3318 15.815 18.1139 17.1997C16.4039 19.1439 14.0036 20.1085 11.6051 20.1013C10.7655 20.0977 7.02406 20.1003 4.81524 20.1013C4.1596 20.1013 3.77107 19.3981 4.13625 18.8727C4.34079 18.5791 4.6023 18.2208 4.80776 17.9415C5.01417 17.6622 5.03286 17.2949 4.85447 16.9985C4.54065 16.475 4.07367 15.6802 3.95226 15.3911C2.50276 12.3772 3.0622 8.69259 5.64833 6.20592C7.831 4.1072 10.914 3.39596 13.7075 4.07038",
    stroke: "#E07E9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.506 12.2136V12.278M14.7774 12.2275C14.7774 12.3726 14.6551 12.4901 14.5042 12.4901C14.3534 12.4901 14.2312 12.3726 14.2312 12.2275C14.2312 12.0824 14.3534 11.9648 14.5042 11.9648C14.6551 11.9648 14.7774 12.0824 14.7774 12.2275Z",
    stroke: "#E07E9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1153 12.2136V12.278M9.38685 12.2275C9.38685 12.3726 9.26446 12.4901 9.11363 12.4901C8.96279 12.4901 8.84058 12.3726 8.84058 12.2275C8.84058 12.0824 8.96279 11.9648 9.11363 11.9648C9.26446 11.9648 9.38685 12.0824 9.38685 12.2275Z",
    stroke: "#E07E9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon_4.1bc6cd5835535ac9254e6546bd4bef38.svg";
export { ForwardRef as ReactComponent };